export default __webpack_public_path__ + "static/media/sortIcon.999adb07.svg";